import { render } from "./TermsView.vue?vue&type=template&id=386483e9&scoped=true"
const script = {}

import "./TermsView.vue?vue&type=style&index=0&id=386483e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-386483e9"]])

export default __exports__